import { render, staticRenderFns } from "./documents-container.vue?vue&type=template&id=62f4f764"
import script from "./documents-container.vue?vue&type=script&lang=js"
export * from "./documents-container.vue?vue&type=script&lang=js"
import style0 from "./documents-container.vue?vue&type=style&index=0&id=62f4f764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports